import { LoaddingService } from './../../providers/loadding.service';
import { GameOrderDetailPage } from './gameorderdetail';
import { VrAccountSearchPage } from './search';
import { PageDefault } from './../PageDefault';
import { AppConfig } from './../../app/app.config';
import { VrService } from './../../services/vr.service';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

/**
 * Generated class for the VrgamereportPage page.
 * VR帐变列表
 * TQQ 2018-01-26
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
// @IonicPage({ name: 'vrgamereport' })
@Component({
    selector: 'page-vrgamereport',
    templateUrl: 'vraccountreport.html',
})
export class VraccountreportPage {

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private vrService: VrService,
        private config: AppConfig,
        private modalCtrl: ModalController,
        private loading: LoaddingService
    ) { }

    paras = {
        userName: this.config.getCurrentUser().UserName,
        changeType: '',
        startDate: PageDefault.endNowDate(),
        endDate: PageDefault.endDate(),
        pageIndex: 1,
        pageSize: PageDefault.PageSize()
    };
    modelList = [];
    sumList;
    hasmore = false;
    isHave = true;

    ionViewDidLoad() {
        this.getAccountChangeReport();
    }

    //下拉重新加载
    //TQQ 2018-01-26
    doRefresh(refresher) {
        this.paras.pageIndex = 1;
        this.getAccountChangeReport().then(() => {
            refresher.complete();
        });
    }

    //上拉获取下一页信息
    //TQQ 2018-01-26
    doInfinite(infiniteScroll) {
        this.paras.pageIndex++;
        this.getAccountChangeReport().then(() => {
            infiniteScroll.complete();
        });
    }

    //查询条件
    //TQQ 2018-01-26
    presentFilter() {
        let modal = this.modalCtrl.create(VrAccountSearchPage, { paras: this.paras });
        modal.present();
        modal.onWillDismiss(data => {
            if (data) {
                this.paras = data;
                this.getAccountChangeReport();
            }
        });
    }

    //获取vr帐变流水信息
    //TQQ 2018-01-26
    getAccountChangeReport() {
        let load = this.loading.showLoding();
        return this.vrService.getAccountChangeReport(this.paras).then(s => {
            if (s.List != null) {
                if (this.paras.pageIndex == 1) {
                    this.modelList = [];
                    this.modelList = s.List;
                    if (s.List.length < s.PageCount) {
                        this.hasmore = true;
                    } else {
                        this.hasmore = false;
                    }
                } else {
                    this.modelList = this.modelList.concat(s.List);
                    if (this.modelList.length < s.PageCount) {
                        this.hasmore = true;
                    }
                    else {
                        this.paras.pageIndex = 1;
                        this.hasmore = false;
                    }
                }
            } else {
                this.modelList = [];
            }
            if (s.ListExt && s.ListExt.length > 0) {
                this.sumList = s.ListExt[0];
            }
            if (this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
            this.loading.closeLoading(load);
        }).catch(() => {
            this.loading.closeLoading(load);
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/vraccountreport/vraccountreport.ts